import React from "react";

export const { Provider, Consumer } = React.createContext({
  focused: null,
  focusSelected: () => null
});



// WEBPACK FOOTER //
// ./src/components/KeyboardNavigation/Context.js